import { render, staticRenderFns } from "./loadingBase.vue?vue&type=template&id=78876b64&scoped=true&"
import script from "./loadingBase.vue?vue&type=script&lang=js&"
export * from "./loadingBase.vue?vue&type=script&lang=js&"
import style0 from "./loadingBase.vue?vue&type=style&index=0&id=78876b64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78876b64",
  null
  
)

export default component.exports